/* breakpoints.js */
export default function(bp) {
    switch(bp) {
        case 'sm':
            return 640;
        case 'md':
            return 768;
        case 'lg':
            return 1024;
        case 'xl':
            return 1280;
        case '2xl':
            return 1536;
        default:
            return 0;
    }
}
